import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import i18n from './i18n.js';


Vue.use(VueRouter);

const lazyRoutes = {
    login: () => import(/* webpackChunkName: "login" */ '../components/login/login.vue'),
    //setPassword: () => import(/* webpackChunkName: "login" */ '../components/login/setpassword.vue'),
    //editProfile: () => import(/* webpackChunkName: "login" */ '../components/login/editprofile.vue'),
    //editReadOnlyProfile: () => import(/* webpackChunkName: "login" */ '../components/login/editprofilereadonly.vue'),
    //forgotPassword: () => import(/* webpackChunkName: "login" */ '../components/login/forgotpassword.vue'),
    //twofactor: () => import(/* webpackChunkName: "login" */ '../components/login/components/twofactor.vue'),
    //resetPassword: () => import(/* webpackChunkName: "login" */ '../components/login/resetpassword.vue'),

    home: () => import(/* webpackChunkName: "home" */ '../components/home/home.vue'),

    
};


const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters['auth/isAuthenticated']) {
        next();
        return;
    }
    next('/');
};

const ifAuthenticated = (to, from, next) => {
    if (store.getters['auth/isAuthenticated']) {
        next();
        return;
    }
    next('/login');
};

const routes = [
    {
        name: 'login',
        path: i18n.t('path.login'),
        component: lazyRoutes.login,
        beforeEnter: ifNotAuthenticated,
        meta: { title: 'title.portal' }
    },
    {
        name: 'home',
        path: i18n.t('path.home'),
        component: lazyRoutes.home,
        beforeEnter: ifAuthenticated,
        meta: { title: 'title.portal' }
    },
    
];

const router = new VueRouter({ mode: 'history', routes });

router.afterEach((to, from) => {
    document.title = i18n.t(to.meta.title);
});

export default router;